var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-chart"},[_c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"series":_vm.series,"options":_vm.options}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }